/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormRecaptcha64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormRecaptcha64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M22 40.4848L24.236 38.2488C26.0786 40.4848 28.8419 41.932 31.9999 41.932C35.2227 41.932 38.1178 40.4171 39.8935 37.9845L36.2096 34.2336C35.8804 34.8905 34.0137 36.8643 31.9343 36.8643C29.8528 36.8643 28.71 35.7456 27.9213 34.5613L30.4864 31.9976C27.1966 31.9321 23.5127 31.9321 22 31.9976V40.4826V40.4848Z"
            fill="currentColor"
          />
          <path
            opacity="0.6"
            d="M31.9332 22H23.4454L25.6813 24.236C23.5779 25.882 22.2626 28.3146 22.0645 31.0786H27.1955C27.4591 29.7632 28.3142 28.6445 29.3659 27.9868L31.9325 30.5534C31.9981 27.198 31.9981 23.5142 31.9325 22.0015L31.9332 22Z"
            fill="currentColor"
          />
          <path
            opacity="0.3"
            d="M42.0001 31.9328V23.4478L39.7619 25.6837C38.1181 23.5789 35.5522 22.3284 32.8545 22.0654V27.1965C34.2361 27.3931 35.4204 28.3152 36.1436 29.3669L33.5755 31.9328H42.0001Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormRecaptcha64Icon.tags = [
  'captcha',
  'security',
  'verification',
  'robot',
  'protection',
];

AddPanelFormRecaptcha64Icon.category = '64x64 (Add panel)';

AddPanelFormRecaptcha64Icon.iconSize = 64;
